export const getWebsiteURL = () => {
  const env = process.env.RAILS_ENV;
  const dynamicPublicWebsiteURL = process.env.PUBLIC_WEBSITE_URL;
  if (env === "production") {
    // return dynamicPublicWebsiteURL || "https://www.magiclinks.com/";
    return "https://www.magiclinks.com/";
  } else if (env === "staging") {
    // return dynamicPublicWebsiteURL || "https://staging.magikops.com/";
    return "https://staging.magikops.com/";
  } else if (env === "development") {
    return dynamicPublicWebsiteURL || "http://localhost:3013/";
  }
};

export const getTikTokAuthOrigin = () => {
  const env = process.env.RAILS_ENV;
  let authOrigin = "";
  if (env === "production") {
    authOrigin = "https://app.magiclinks.com";
  } else if (env === "staging") {
    authOrigin = "https://stg1.magiclinks.biz";
  } else {
    authOrigin = "https://magiclinks.ngrok.io";
  }
  return authOrigin;
};

export const getAssetsCentral = () => {
  const env = process.env.RAILS_ENV;
  if (env === "production") {
    return "https://asset.magiclinks.com/assets";
  } else if (env === "staging") {
    return "https://asset.staging.magikops.com/assets";
  }
  return "https://asset.staging.magikops.com/assets";
};

export const inbioBaseURL =
  process.env.RAILS_ENV === "production"
    ? "https://in-bio.io"
    : "https://inbio.staging.magikops.com";
